<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Leaderboards</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row>
        <b-col lg="3" md="4">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <strong>LEADERBOARDS</strong>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center" button v-for="(leaderboard, key) in leaderboards" @click="activeLeaderboard = leaderboard.value" :key="key" :active="activeLeaderboard == leaderboard.value">
              <span>{{ leaderboard.title }}</span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col lg="9" md="8">
          <sales-leaderboard :userRoute="userRoute" v-if="activeLeaderboard == 'sales'"></sales-leaderboard>
          <leaderboard :title="title" :userRoute="userRoute" :activeLeaderboard="activeLeaderboard" v-if="isActiveLeaderboard"></leaderboard>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import trackingSources from './trackingSources';
import SalesLeaderboard from './SalesLeaderboard';
import { Select, Option } from 'element-ui';
import Leaderboard from './Leaderboard';

export default {
  components: {
    RouteBreadCrumb,
    SalesLeaderboard,
    [Select.name]: Select,
    [Option.name]: Option,
    Leaderboard
  },
  data() {
    return {
      trackingSources: trackingSources,
      activeLeaderboard: 'sales',
      leaderboards: [],
    }
  },
  computed: {
    userRoute() {
      return process.env.VUE_APP_API_BASE_URL + '/users/' + this.$route.params.user;
    },
    isActiveLeaderboard() {
      return this.activeLeaderboard.length > 0 && this.activeLeaderboard !== 'sales';
    },
    title() {
      if (this.leaderboards.length > 0) {
        return this.leaderboards.filter((l) => {
          return l.value == this.activeLeaderboard;
        })[0].title;
      } else {
        return '';
      }
    }
  },
  methods: {
    async getLeaderboardMenu() {
      await axios.get(this.userRoute + "/leaderboards/menu?section=team")
      .then(response => {
        this.mapMenu(response.data);
      })
    },
    async getCustomTrackingSources() {
      await axios.get(this.userRoute + "/tracking-sources")
      .then(response => {
        response.data.forEach((source) => {
          this.trackingSources.push({ value: source.slug, label:source.name });
        });
        this.getLeaderboardMenu();
      })
      .catch(error => {
        // error
      });
    },
    mapMenu(menu) {
      this.leaderboards = [
        {
          title: 'Sales Leaderboard',
          value: 'sales',
        }
      ];

      menu.forEach((item) => {
        let source = this.trackingSources.filter((s) => {
          return s.value == item.type;
        })[0];

        if (source) {
          this.leaderboards.push({title: source.label, value: source.value});
        }
      });
    }
  },
  created() {
    this.getCustomTrackingSources();
  }
};
</script>
<style lang="scss">
.list-group-item.active {
  background-color: #7aa2b8 !important;
  border-color: #7aa2b8 !important;
}
</style>